import { render, staticRenderFns } from "./TransitionHeight.vue?vue&type=template&id=05359c61&scoped=true&"
import script from "./TransitionHeight.vue?vue&type=script&lang=js&"
export * from "./TransitionHeight.vue?vue&type=script&lang=js&"
import style0 from "./TransitionHeight.vue?vue&type=style&index=0&id=05359c61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05359c61",
  null
  
)

export default component.exports